import React from 'react'
import QuestionnaireDashboardProfileWrapper from './QuestionnaireDashboardProfileWrapper'
import FullQuestionnaireDashboardComponent from './FullQuestionnaireDashboardComponent'

const FullQuestionnaireDashboard = (props) => {
  return <QuestionnaireDashboardProfileWrapper component={FullQuestionnaireDashboardComponent} {...props} />
}

export default FullQuestionnaireDashboard
